<template>
  <div class="container">
    <content-header :data="[{text:'二维码管理', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">创建二维码文件</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="PDF文件ID"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="活动名称"
            width="200"
            fixed>
          </el-table-column>
          <el-table-column
            prop="number"
            label="二维码个数">
          </el-table-column>
          <el-table-column
            label="内容提示">
            <template slot-scope="scope">
              <span v-html="scope.row.title"></span>
            </template>
          </el-table-column>
          <el-table-column
            label="扫码提示"
            width="120">
            <template slot-scope="scope">
              <span v-html="scope.row.tips"></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="downloaded"
            label="下载次数">
          </el-table-column>
          <el-table-column
            prop="created"
            label="创建时间"
            width="180">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="downloadHandle(scope)" type="text" size="small">下载</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改二维码PDF文件' : '创建二维码PDF文件'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="number" label="二维码个数" :label-width="formLabelWidth">
              <el-input name="number" v-model.number="curObj.number" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="title" label="内容提示" :label-width="formLabelWidth">
              <el-input name="title" v-model="curObj.title" placeholder="例如促销的商品品牌" auto-complete="off"></el-input>
              <el-tooltip class="item" effect="dark" content="(半角逗号,分隔可换行)" placement="bottom">
                <i class="iconfont icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item prop="tips" label="扫码提示" :label-width="formLabelWidth">
              <el-input name="tips" v-model="curObj.tips" placeholder="例如促销的商品品牌" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import {showLoading, hideLoading} from 'components/loading'
  import RedEnvelopeModel from 'models/redenvelope'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        isObjShow: false,
        curObj: {
          id: '',
          redEnvelopeId: '',
          type: '',
          number: '',
          title: '',
          tips: '请扫描右侧二维码',
        },
        formLabelWidth: '120px',
        curObjRules: {
          number: [{ required: true, message: '请输入编号', trigger: 'blur' },
            { type: 'number', message: '必须为数值' }],
          title: [{ required: true, message: '请输入内容提示', trigger: 'blur' }],
          tips: [{ required: true, message: '请输入扫码提示', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
      }
    },
    created () {
      this.curObj.redEnvelopeId = this.$route.query.redEnvelopeId
      this.curObj.type = this.$route.query.type
      if (this.curObj.redEnvelopeId) {
        this.getObjList({redEnvelopeId: this.curObj.redEnvelopeId, type: this.curObj.type})
      }
    },
    methods: {
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        RedEnvelopeModel.findQRCode(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      deleteHandle (item) {
        this.$confirm('确认删除？')
          .then(_ => {
            RedEnvelopeModel.deleteQRCode({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj.id = ''
        this.curObj.number = ''
        this.curObj.title = ''
        this.curObj.tips = '请扫描右侧二维码'
        this.isObjShow = true
      },
      newHandle () {
        showLoading()
        RedEnvelopeModel.createQRCode(this.curObj).then(() => {
          this.getObjList({redEnvelopeId: this.curObj.redEnvelopeId, type: this.curObj.type})
          this.$message({ message: '添加成功', type: 'success' })
          this.isObjShow = false
          hideLoading()
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
          this.isObjShow = false
          hideLoading()
        })
      },
      //
      downloadHandle (item, event, column) {
        RedEnvelopeModel.downloadQRCode({id: item.row.id, redEnvelopeId: this.curObj.redEnvelopeId, type: this.curObj.type})
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
</style>



// WEBPACK FOOTER //
// src/views/QRCode.vue